import React from 'react';
import {
  StyleSheet, Document, Page, View, Text
} from '@react-pdf/renderer';

import { toBrazilDate, toBrazilDateTime } from '../../../../components/mask';

export default function print({ data, startDate, endDate }: any) {
  const toDecimal = (value: number) => value?.toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

  const styles = StyleSheet.create({
    body: {
      padding: 10,
      paddingBottom: 60
    },
    table: {
      width: 'auto',
      borderStyle: 'solid',
      borderColor: '#bfbfbf',
      borderWidth: 1,
      borderRightWidth: 0,
      borderBottomWidth: 0
    },
    tableRow: {
      margin: 'auto',
      flexDirection: 'row'
    },
    tableColHeader: {
      width: '8%',
      borderStyle: 'solid',
      borderColor: '#bfbfbf',
      borderBottomColor: '#000',
      borderWidth: 1,
      borderLeftWidth: 0,
      borderTopWidth: 0
    },
    tableColTextHeader: {
      width: '44%',
      borderStyle: 'solid',
      borderColor: '#bfbfbf',
      borderBottomColor: '#000',
      borderWidth: 1,
      borderLeftWidth: 0,
      borderTopWidth: 0
    },
    tableCol: {
      width: '8%',
      borderStyle: 'solid',
      borderColor: '#bfbfbf',
      borderWidth: 1,
      borderLeftWidth: 0,
      borderTopWidth: 0
    },
    tableTextCol: {
      width: '44%',
      borderStyle: 'solid',
      borderColor: '#bfbfbf',
      borderWidth: 1,
      borderLeftWidth: 0,
      borderTopWidth: 0
    },
    tableCellHeader: {
      margin: 'auto',
      fontSize: 12,
      fontWeight: 500
    },
    tableCell: {
      fontSize: 10
    },
    tableMoneyCell: {
      fontSize: 10,
      textAlign: 'right'
    },
    header: {
      fontSize: 12,
      marginBottom: 20,
      textAlign: 'center',
      color: 'grey'
    },
    pageNumber: {
      position: 'absolute',
      fontSize: 12,
      bottom: 30,
      left: 0,
      right: 0,
      textAlign: 'center',
      color: 'grey'
    }
  });

  return (
    <Document>
      <Page size="A4" orientation="landscape" style={styles.body}>
        <Text style={styles.header} fixed>
          {`${toBrazilDate(startDate)} a ${toBrazilDate(endDate)}`}
        </Text>
        <View style={styles.table}>
          <View style={styles.tableRow}>
            <View style={styles.tableColTextHeader}>
              <Text style={styles.tableCellHeader}>Cliente</Text>
            </View>
            <View style={styles.tableColHeader}>
              <Text style={styles.tableCellHeader}>Dinheiro</Text>
            </View>
            <View style={styles.tableColHeader}>
              <Text style={styles.tableCellHeader}>Débito</Text>
            </View>
            <View style={styles.tableColHeader}>
              <Text style={styles.tableCellHeader}>Crédito</Text>
            </View>
            <View style={styles.tableColHeader}>
              <Text style={styles.tableCellHeader}>Pix</Text>
            </View>
            <View style={styles.tableColHeader}>
              <Text style={styles.tableCellHeader}>Picpay</Text>
            </View>
            <View style={styles.tableColHeader}>
              <Text style={styles.tableCellHeader}>Faturado</Text>
            </View>
            <View style={styles.tableColHeader}>
              <Text style={styles.tableCellHeader}>Total</Text>
            </View>
          </View>
          {data.map((x: any) => (
            <View style={styles.tableRow} key={x.Id} wrap={false}>
              <View style={styles.tableTextCol}>
                <Text style={styles.tableCell}>{x.Cliente}</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableMoneyCell}>{toDecimal(x.Dinheiro)}</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableMoneyCell}>{toDecimal(x.Debito)}</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableMoneyCell}>{toDecimal(x.Credito)}</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableMoneyCell}>{toDecimal(x.Pix)}</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableMoneyCell}>{toDecimal(x.Picpay)}</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableMoneyCell}>{toDecimal(x.Faturado)}</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableMoneyCell}>{toDecimal(x.Total)}</Text>
              </View>
            </View>
          ))}
        </View>
        <Text
          style={styles.pageNumber}
          render={({ pageNumber, totalPages }) => (
            `${pageNumber} / ${totalPages}\n${toBrazilDateTime(new Date())}`
          )}
          fixed
        />
      </Page>
    </Document>
  );
}
